import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { articles } from '../articles';
import AdSenseAd from '../components/AdSenseAd'; // Import AdSenseAd component
import './Article.css';

const Article = () => {
  const { slug } = useParams();
  const article = articles.find((p) => p.slug === slug);

  if (!article) {
    return (
      <div className="article-container">
        <Helmet>
          <title>게시물을 찾을 수 없습니다 - 두바이 쫀득쿠키 블로그</title>
          <meta name="description" content="요청하신 게시물을 찾을 수 없습니다." />
        </Helmet>
        <h2>게시물을 찾을 수 없습니다.</h2>
        <Link to="/blog">블로그 목록으로 돌아가기</Link>
      </div>
    );
  }

  return (
    <article className="article-container">
      <Helmet>
        <title>{article.title} - 두바이 쫀득쿠키</title>
        <meta name="description" content={article.summary} />
        <meta property="og:title" content={article.title} />
        <meta property="og:description" content={article.summary} />
        <meta property="og:type" content="article" />
      </Helmet>
      <header className="article-header">
        <h1>{article.title}</h1>
      </header>
      
      <p className="article-summary">{article.summary}</p>

      <AdSenseAd slot="YOUR_ARTICLE_TOP_AD_SLOT_ID" /> {/* AdSense Ad */}

      <div
        className="article-content"
        dangerouslySetInnerHTML={{ __html: article.content }}
      />

      <AdSenseAd slot="YOUR_ARTICLE_BOTTOM_AD_SLOT_ID" /> {/* AdSense Ad */}
    </article>
  );
};

export default Article;
